import { createLog } from '@iv/shared/src/log';

export const log = createLog('adapter-bridge');
